const findEnumValue = (errorEnum, numericCode) => {
    for (const [, value] of Object.entries(errorEnum)) {
        if (value === numericCode) {
            return value;
        }
    }
    return null;
};
export function getErrorType(errorCode, errorEnums) {
    if (!errorCode) {
        return null;
    }
    const parts = errorCode.split("-");
    const lastPart = parts[parts.length - 1];
    if (!lastPart) {
        return null;
    }
    const numericCode = parseInt(lastPart, 10);
    if (isNaN(numericCode)) {
        return null;
    }
    // Handle array of enums or single enum
    const enumsToCheck = Array.isArray(errorEnums) ? errorEnums : [errorEnums];
    for (const currentEnum of enumsToCheck) {
        const match = findEnumValue(currentEnum, numericCode);
        if (match !== null) {
            return match;
        }
    }
    return null;
}
